import React from "react";
import Web3 from "web3";
import styled from "styled-components";
import ProgressImg from "../../assets/img/progress.png";
import BigNumber from "bignumber.js";

const ProgressBoxStyle = styled.div`
  @keyframes progress-bar-stripes {
    from {
      background-position: 40px 0;
    }

    to {
      background-position: 0 0;
    }
  }
  @keyframes animate-positive {
    0% {
      width: 0;
    }
  }
  width: 100%;
  min-height: 200px;
  background-color: #fff;
  border-radius: 12px 0px 0px 12px;
  box-shadow: 6px 6px 19px -3px rgba(13, 64, 152, 0.16);
  padding: 20px;
  flex-basis: 100%;
  color: #2a2d35;
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  &:hover {
    box-shadow: 6px 6px 19px -3px rgba(29, 38, 54, 0.25);
  }
  > h3 {
    color: #2a2d35;
  }
  .real-number {
    margin: 10px 0;
    > span:last-child {
      font-size: 16px;
      margin-left: 8px;
    }
  }
  .progress-box {
    border-radius: 3px;
    border: 1px solid #229f20;
    height: 40px;
    padding: 5px;
    .pro-box {
      height: 100%;
      border-radius: 3px;
      /* background: url(${ProgressImg}) no-repeat;
      background-position: center;
      background-size: cover; */
      background: repeating-linear-gradient(
        45deg,
        #e1e6eb,
        #e1e6eb 15px,
        #e8ecef 0,
        #e8ecef 30px
      );
      flex: 2 1;
      display: flex;
      /* flex-direction: row-reverse; */
      .pro-line {
        height: 100%;
        transition: width 0.6s ease;
        border-radius: 3px;
        background-color: #229f20;
        background-image: linear-gradient(
          45deg,
          hsla(0, 0%, 100%, 0.15) 25%,
          transparent 0,
          transparent 50%,
          hsla(0, 0%, 100%, 0.15) 0,
          hsla(0, 0%, 100%, 0.15) 75%,
          transparent 0,
          transparent
        );
        background-size: 40px 40px;
        animation: progress-bar-stripes 0.6s linear infinite,
          animate-positive 2s;
      }
    }
  }
  .all-number {
    display: flex;
    justify-content: space-between;
    color: #7d8a96;
    margin: 10px 0;
    font-size: 16px;
    .mtr6 {
      margin-right: 6px;
    }
  }
`;

export default function ProgressBox({ stakeInfo }) {
  const { fromWei } = Web3.utils;

  const progress =
    stakeInfo.top && stakeInfo.total
      ? new BigNumber(stakeInfo.total)
          .dividedBy(stakeInfo.top)
          .multipliedBy(100)
          .toString()
      : 0;

  return (
    <ProgressBoxStyle>
      <h3>Real-time Grant Progress</h3>
      <div className="real-number">
        <span>
          {stakeInfo.total
            ? new BigNumber(fromWei(stakeInfo.total)).toFixed(2).toString()
            : "-"}
        </span>
        <span>TRIAS</span>
      </div>
      <div className="progress-box">
        <div className="pro-box">
          <div
            className="pro-line"
            style={{ width: `${Number(progress) > 1 ? progress : 1}%` }}
            title={progress + "%"}
          />
        </div>
      </div>
      <div className="all-number">
        <div>
          <span className="mtr6">0</span>
          <span>TRIAS</span>
        </div>
        <div>
          <span className="mtr6">
            {stakeInfo.top ? fromWei(stakeInfo.top) : "-"}
          </span>
          <span>TRIAS</span>
        </div>
      </div>
    </ProgressBoxStyle>
  );
}
